import angular from 'angular';
import Data from 'cars-ng-user/lib/data';
import Summary from 'cars-ng-user/lib/summary';

export default angular.module('cars.user', [
    Data,
    Summary
])
    .config([() => {}])
    .name;
